module.exports = __webpack_public_path__ + "static/media/lag_wtf.627f9118.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/lag_wtf.png
// module id = 1486
// module chunks = 39